import React, { useState } from 'react';
import { Card, Input, Modal } from 'components';
import {
  protectUserInfo,
  userInfoSelector,
} from 'redux/slices/profile/UserInfoSlice';
import { useDispatch, useSelector } from 'react-redux';
import { isUserCompanySelector } from 'redux/slices/signUp/signUpSlice';
import UserInfoModule from './UserInfoModule';
import { apiResHandler } from 'utils/axiosBaseQuery';
import { useUpdateUserInfoMutation } from 'redux/slices/profile/userInfoApi';
import PropTypes from 'prop-types';
import { addAlertQueue } from 'redux/slices/snackbar/snackbarSlice';

const UserInfo = ({
  fullName,
  taxNumber,
  identityNumber,
  companyName,
  telephone,
  email,
  username,
}) => {
  const dispatch = useDispatch();
  const userInfo = useSelector(userInfoSelector);
  const isUserCompany = useSelector(isUserCompanySelector);
  const [visibility, setVisibility] = useState(false);
  const handleOnClick = () => {
    setVisibility(true);
  };
  const handleOnClose = () => {
    dispatch(protectUserInfo()), setVisibility(false);
  };
  const [updateUserInfo] = useUpdateUserInfoMutation();

  const handleOnSubmit = () => {
    apiResHandler(
      updateUserInfo({ data: userInfo }),
      () => {
        dispatch(
          addAlertQueue({
            message: 'Başarı ile bilgiler güncellendi.',
            status: 'success',
            show: true,
          })
        );
        setVisibility(false);
      },
      ({ message }) => {
        dispatch(
          addAlertQueue({
            message: message || 'Hata oluştu',
            status: 'error',
            show: true,
          })
        );
      }
    );
  };

  return (
    <>
      <Card className="flex content-start gap-y-4">
        <div className="text-large text-primary font-bold text-start ">
          Hesap Bilgileri
          <div
            onClick={handleOnClick}
            className="float-right block text-ink-dark text-small mt-16 cursor-pointer hover:text-primary "
          >
            Düzenle
          </div>
        </div>

        <>
          <Input
            className="flex  items-center w-auto text-center gap-x-4"
            label="Adı Soyadı :"
            labelClassName="w-52 text-start"
            inputWrapperClassName="w-72"
            type="text"
            value={fullName}
            disabled
          />
        </>
        {isUserCompany ? (
          <Input
            className="flex  items-center w-auto text-center gap-x-4"
            label="Vergi Numarası : "
            labelClassName="w-52 text-start"
            inputWrapperClassName="w-72"
            value={taxNumber}
            type="text"
            disabled
          />
        ) : (
          <Input
            className="flex  items-center w-auto text-center gap-x-4"
            label="TC Kimlik Numarası :"
            labelClassName="w-52 text-start"
            inputWrapperClassName="w-72"
            value={identityNumber}
            type="text"
            disabled
          />
        )}
        <>
          <Input
            className="flex  items-center w-auto text-center gap-x-4"
            label="Şirket Adı :"
            labelClassName="w-52 text-start"
            inputWrapperClassName="w-72"
            type="text"
            disabled
            value={companyName}
          />
        </>
        <>
          <Input
            className="flex  items-center w-auto text-center gap-x-4"
            label="Telefon Numarası :"
            labelClassName="w-52 text-start"
            inputWrapperClassName="w-72"
            type="text"
            disabled
            value={telephone}
          />
        </>
        <>
          <Input
            className="flex  items-center w-auto text-center gap-x-4"
            labelClassName="w-52 text-start"
            inputWrapperClassName="w-72"
            label="E-mail Adresi :"
            type="text"
            disabled
            value={email}
          />
        </>
        <>
          <Input
            className="flex  items-center w-auto text-center gap-x-4"
            label="Kullanıcı Adı :"
            labelClassName="w-52 text-start"
            inputWrapperClassName="w-72"
            value={username}
            type="text"
            disabled
          />
        </>
      </Card>
      <Modal
        className="backdrop-blur w-fit"
        ModalClass="md:p-24"
        ModalContentClass=" "
        isOpen={visibility}
        handleModalClose={handleOnClose}
      >
        <UserInfoModule onSubmit={() => handleOnSubmit()} />
      </Modal>
    </>
  );
};

UserInfo.propTypes = {
  fullName: PropTypes.any,
  taxNumber: PropTypes.any,
  companyName: PropTypes.string,
  identityNumber: PropTypes.string,
  telephone: PropTypes.string,
  email: PropTypes.string,
  username: PropTypes.string,
};

export default UserInfo;
